import React from 'react';

import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';

import {
    useCurrentDebrief,
    useMapSettings,
    useAnalytics,
} from 'ff/debrief/hooks';
import { LinkToDebrief } from 'ff/debrief/router';

interface Props {}

const DebriefButton: React.FC<Props> = () => {
    const { debrief, isLoading, isPending, isProcessing, isError, hasDebrief } =
        useCurrentDebrief();
    const { resetMap } = useMapSettings();
    const { logEvent } = useAnalytics();

    const handleClick = () => {
        resetMap();
        logEvent('Debrief, Debrief Button Clicked', {
            score: debrief.score,
            iapCount: debrief.instrumentProcedureCount,
        });
    };

    if (isLoading || isError) {
        return (
            <Button variant="contained" size="small" disabled>
                <Skeleton variant="rounded" height={10} width={30} />
            </Button>
        );
    } else if (isPending || isProcessing) {
        return (
            <Button variant="contained" size="small" disabled>
                Analyzing...
            </Button>
        );
    } else if (hasDebrief) {
        return (
            <Button
                component={LinkToDebrief}
                onClick={handleClick}
                variant="contained"
                size="small"
            >
                Debrief
            </Button>
        );
    } else {
        return (
            <Button component={LinkToDebrief} variant="outlined">
                Details
            </Button>
        );
    }
};

export default DebriefButton;
